import GoGroupBtn from "./go-group-btn/index";
import GoBtnGroup from "./go-tool-bar/go-btn-group.vue";
import GoBtn from "./go-tool-bar/go-btn.vue";
import GoBtnCheck from "./go-tool-bar/go-btn-check.vue";
import GoBtnIcon from "./go-tool-bar/go-btn-icon.vue";
import GoBtnSelect from "./go-tool-bar/go-btn-select.vue";
import GoUpload from "./go-tool-bar/go-upload.vue";
import GoToolBar from "./go-tool-bar/index";
import GoLine from "./go-line.vue";
import GoImgPageList from "./go-img-page-list.vue";
import GoSearchBox from "./go-search-box.vue";
import GoSearchMore from "./go-search-more.vue";
import GoSimpleMenu from "./go-simple-menu.vue";
import GoSimpleTree from "./go-simple-tree.vue";
import GoSingleGrid from "./go-single-grid.vue";
import GoTreeGrid from "./go-tree-grid.vue";
import GoEditorGrid from "./go-editor-grid.vue";
import GoTree from "./go-tree.vue";
import GoPanelTitle from "./go-panel-title.vue";
import GoPageFooterBar from "./go-page-footer-bar.vue";
import GoTreeAsyn from "./go-tree-asyn.vue";
import GoPreview from "./go-picture-view/goPreview.vue";
//普通窗口
import GoWin from "./go-win.vue";
//树窗口
import GoWinTree from "./go-win-tree";
//树窗口
import GoWinForm from "./go-win-form";
//授权窗口
import GoWinAcl from "./go-win-acl";
//授权窗口
import GoWinGrid from "./go-win-grid";
//新增修改窗口
import GoAddModWin from "./go-add-mod-win.vue";
import GoImgList from "./go-img-ctl/go-img-list.vue";
import GoImgUpload from "./go-img-ctl/go-img-upload/index.vue";
import GoImgSelPanel from "./go-img-ctl/go-img-sel-panel/index.vue";
import GoUploadExcelWin from "./go-upload-excel-win.vue";
import GoCardGrid from './go-card-grid/index';

export default {
    GoGroupBtn,
    GoBtnCheck,
    GoBtnIcon,
    GoToolBar,
    GoLine,
    GoAddModWin,
    GoWin,
    GoBtn,
    GoBtnSelect,
    GoImgList,
    GoImgPageList,
    GoSimpleTree,
    GoBtnGroup,
    GoEditorGrid,
    GoSearchBox,
    GoSearchMore,
    GoPanelTitle,
    GoImgUpload,
    GoImgSelPanel,
    GoSingleGrid,
    GoTree,
    GoTreeAsyn,
    GoPageFooterBar,
    GoUpload,
    GoSimpleMenu,
    GoUploadExcelWin,
    GoPreview,
    GoCardGrid,
    GoWinTree,
    GoWinForm,
    GoWinAcl,
    GoWinGrid,
    GoTreeGrid,
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/index.js